export default __webpack_public_path__ + "129745514823a9a03d0b34c4d6019ed0.svg";